// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","976":"c16184b3"}[chunkId] + "-" + {"678":"7693446862d435a26f52","976":"cf2d30ab26c7c934b260"}[chunkId] + ".js";
};